module.exports = {"es-PY":{"components":{"paginator":{"first":"","prev":"","next":"","last":""}}}}